import findVideos from './video-finder';
import { modalTitleSizeChecker } from './video-titles-size';

function videoModalinit() {
	let modalBtns = document.querySelectorAll('.js-video-modal-btn');
	let overlay = document.querySelector('.js-modal-overlay');
	let modal = document.querySelector('.js-video-modal');
	let closeBtn = modal.querySelector('.js-video-modal-close');
	let videoBox = modal.querySelector('.js-academy-video-box');

	const originalVideoBoxHTML = videoBox.innerHTML;

	function openModal(videoUrl, videoTitle) {
		videoBox.setAttribute('data-video-url', videoUrl);
		findVideos();

		let videoModalTitle = modal.querySelector('.js-video-modal-title');
		videoModalTitle.innerHTML = videoTitle;
		modalTitleSizeChecker();

		modal.classList.add('open');
		overlay.classList.add('open');
	}

	function closeModal() {
		modal.classList.remove('open');
		overlay.classList.remove('open');

		videoBox.setAttribute('data-video-url', '');
		videoBox.innerHTML = '';
		videoBox.innerHTML = originalVideoBoxHTML;
	}

	modalBtns.forEach(function (btn) {
		btn.addEventListener('click', function () {
			let videoUrl = btn.getAttribute('data-video-url');
			let videoTitle = btn.getAttribute('data-video-title');

			openModal(videoUrl, videoTitle);
		});
	});

	closeBtn.addEventListener('click', closeModal);

	overlay.addEventListener('click', function (event) {
		if (event.target === overlay) {
			closeModal();
		}
	});
}

export default videoModalinit;
